var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmageMove = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93656 9.93866L5.9367 9.93851C5.96929 9.90601 6.02205 9.90606 6.05457 9.93862C6.08709 9.97118 6.08707 10.0239 6.05453 10.0565C6.02199 10.089 5.96923 10.089 5.93667 10.0565C5.90411 10.024 5.90406 9.97124 5.93656 9.93866",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29609 13.9974C5.31731 13.8595 5.32845 13.7202 5.32943 13.5807V13.5807C5.32943 11.9699 4.02359 10.6641 2.41276 10.6641C2.27326 10.6653 2.13402 10.6765 1.99609 10.6974",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99609 9.3304V12.6637C1.99609 13.4001 2.59305 13.9971 3.32943 13.9971H6.66276C7.39914 13.9971 7.99609 13.4001 7.99609 12.6637V9.3304C7.99609 8.59402 7.39914 7.99707 6.66276 7.99707H3.32943C2.59305 7.99707 1.99609 8.59402 1.99609 9.3304Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99609 5.99707V4.66374C1.99609 3.19098 3.19 1.99707 4.66276 1.99707H11.3294C12.8022 1.99707 13.9961 3.19098 13.9961 4.66374V11.3304C13.9961 12.8032 12.8022 13.9971 11.3294 13.9971H9.99609",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33008 6.66406L11.3301 4.66406",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33008 4.66406H11.3301V6.66406",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmageMove);
export default ForwardRef;